import { Container, Button, Form, Card, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const res = await axios.post("/api/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      const fromPath = location.state?.from?.pathname;
      let safeRedirect =
        typeof fromPath === "string" &&
        fromPath.startsWith("/") &&
        fromPath !== "/login" &&
        fromPath !== "/register"
          ? fromPath
          : "/registry";
      // Calendar registry is the default after login; never send logged-in users to home or public browse
      if (safeRedirect === "/browse" || safeRedirect === "/") {
        safeRedirect = "/registry";
      }
      navigate(safeRedirect, { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <Container
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-4 p-md-5">
          <h2 className="brutal-heading text-center mb-4" style={{ fontSize: "36px" }}>
            LOGIN
          </h2>

          {error && <Alert variant="danger" className="brutal-alert mb-4">{error.toUpperCase()}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Control
              name="email"
              type="email"
              placeholder="EMAIL"
              className="brutal-form-control mb-3"
              required
            />
            <Form.Control
              name="password"
              type="password"
              placeholder="PASSWORD"
              className="brutal-form-control mb-3"
              required
            />

            <div className="text-end mb-4">
              <Button
                variant="link"
                className="brutal-link p-0"
                onClick={() => navigate("/forgot-password")}
                style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
              >
                FORGOT PASSWORD?
              </Button>
            </div>

            <Button
              type="submit"
              className="brutal-btn brutal-btn-primary w-100 mb-4"
            >
              LOGIN
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="brutal-link p-0"
              onClick={() => navigate("/register")}
              style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
            >
              DON'T HAVE AN ACCOUNT? REGISTER!
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
